import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { ScanToPrintReader } from '../../../../../store/scan-to-print/scan-to-print-reader';
import * as Actions from '../../../../../store/scan-to-print/scan-to-print.actions';
import ScaleDropdownItems from '../../../../../components/scale/scale-dropdown-items';
import { useScales } from '../../../../../hooks/scales/use-scales';

import style from '../printer-scale-dropdowns.module.less';

const messages = defineMessages({
  selectScale: {
    description: 'scanToPrint.scaleDropdown.selectScale',
    defaultMessage: 'Select a Scale',
    id: 'JfhHBx',
  },
  scalePrefix: {
    description: 'scanToPrint.scaleDropdown.scalePrefix',
    defaultMessage: 'Scale',
    id: 'wmtV5b',
  },
});

export const ScaleDropdown = ({ inactive }) => {
  const dispatch = useDispatch();
  const { selectedScale, disabled } = useSelector((state) => {
    const scanToPrintReader = new ScanToPrintReader({ state });
    return {
      selectedScale: scanToPrintReader.scale,
      disabled: scanToPrintReader.inVerifyOnlyMode,
    };
  });

  const onScaleSelected = useCallback(
    (scale) => {
      dispatch(Actions.setScanToPrintScale(scale.id));
    },
    [dispatch],
  );

  const elementId = 'scan-scale-dropdown';
  const { enabledScalesGroupedByWorkstation } = useScales();

  return (
    <FlexRow className={style['dropdown-row']}>
      <Text className={style['dropdown-label']} textType={TextType.Label} value={messages.scalePrefix} />
      <DropdownMenu
        className={classnames(style['dropdown-wrapper'], {
          [style.dark]: inactive,
        })}
        disabled={disabled}
        id={elementId}
        menuPosition='bottom-right'
      >
        <DropdownMenuToggler
          className={classnames(style['dropdown-toggler'], {
            [style.dark]: inactive,
          })}
        >
          {selectedScale ? selectedScale.name : <FormattedMessage {...messages.selectScale} />}
        </DropdownMenuToggler>
        <ScaleDropdownItems onSelectScale={onScaleSelected} scalesGroupedByWorkstation={enabledScalesGroupedByWorkstation} />
      </DropdownMenu>
    </FlexRow>
  );
};

ScaleDropdown.propTypes = {
  inactive: PropTypes.bool.isRequired,
};
